/** One way to write an amount of money across the panel. */
export function money(amount: number | null | undefined, currency = 'GHS'): string {
  const value = typeof amount === 'number' && Number.isFinite(amount) ? amount : 0
  return `${currency} ${value.toLocaleString('en-GH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}
